import script from "./RetornoItens.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetornoItens.vue?vue&type=script&setup=true&lang=ts"

import "./RetornoItens.vue?vue&type=style&index=0&id=6360eb20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6360eb20"]])

export default __exports__